import React from "react";
import { FileUp, FileUser } from "lucide-react";

import {
	IconContainer,
	SelectContractTypeButtonContainer,
	SelectContractTypeButtonDescription,
	SelectContractTypeButtonTitle
} from "./styles";

export function SelectContractTypeButton({ type, setStep }) {
	return (
		<SelectContractTypeButtonContainer onClick={setStep}>
			<IconContainer>
				{type === "main" ? (
					<FileUp size={32} color="#312c85" />
				) : (
					<FileUser size={32} color="#312c85" />
				)}
			</IconContainer>

			<SelectContractTypeButtonTitle>
				{type === "main"
					? "Gerar novo contrato principal"
					: "Gerar novo contrato vinculado"}
			</SelectContractTypeButtonTitle>

			<SelectContractTypeButtonDescription>
				{type === "main"
					? "Crie um contrato independente, sem relação direta com outros já existentes."
					: "Crie um contrato vinculado a outro contrato já existente no sistema."}
			</SelectContractTypeButtonDescription>
		</SelectContractTypeButtonContainer>
	);
}
